import { Component, effect, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import {
    FolderValidationErrorObject,
} from '@libs/types/src/services/object-type/folder/folder-validation-error.object';
import {
    ProcedureValidatorErrorEnum,
} from '../../../../../../../../../services/src/domain/service/procedure-validation/types/procedure-validator.error-enum';
import { PersonErrorComponent } from '../../../../components/person/person-error/person-error.component';
import { EmptyStateComponent } from '../../../../../shared/components/empty-state/empty-state.component';
import { LoadingComponent } from '../../../../../../components/kit/loading/loading.component';
import { FilterBuilder } from '../../../../helper/filter.builder';
import { voucherDetailUri } from '../../../../../../utils/router.utils';
import { ErrorsInFolderWidgetStore } from './errors-in-folder-widget.store';
import { getErrorsFrag } from './errors-in-folder-widget.query';

@Component({
    selector: 'app-errors-in-folder-widget',
    templateUrl: './errors-in-folder-widget.component.html',
    providers: [ErrorsInFolderWidgetStore],
    imports: [
        PersonErrorComponent,
        TranslatePipe,
        EmptyStateComponent,
        LoadingComponent,
    ],
})
export class ErrorsInFolderWidgetComponent {
    protected readonly store = inject(ErrorsInFolderWidgetStore);
    private readonly router = inject(Router);

    public readonly serviceIds = input<string[]>([]);

    constructor() {
        effect(() => {
            const serviceIds = this.serviceIds();
            if (!serviceIds.length) return;

            this.store.api.getFolderValidationErrors(
                FilterBuilder.filter({
                    silent: false,
                    error: ProcedureValidatorErrorEnum.NEW_PROCEDURE_ON_VOUCHER,
                    serviceId: serviceIds,
                    organizationId: this.store.organizationId(),
                }),
                getErrorsFrag,
            ).then();
        });
    }

    protected async goToVoucher(error: FolderValidationErrorObject): Promise<void> {
        const { voucherId } = JSON.parse(error.data) as { voucherId?: number };
        if (!voucherId) return;

        await this.router.navigateByUrl(
            voucherDetailUri({ folderId: error.folderId, voucherId }, error.serviceId),
        );
    }
}
